module.exports = __webpack_public_path__ + "img/SportStar.94e27ac2.jpeg";